import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=735b8496"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=735b8496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports